import Plan from './plan';

const Plans = () => {
  return (
    <div className="flex flex-col justify-center items-center h-screen w-full bg-lightblue">
      <div className="-mt-20">
        <h1 className="text-3xl font-bold text-center">Select Your Plan</h1>
        <div className="flex mt-5 space-x-8">
          <Plan />
          <Plan />
          <Plan />
        </div>
      </div>
    </div>
  );
};

export default Plans;
